import { fonts } from "assets/fontStyles";
import colours from "assets/colours";

const inputOverride = {
  width: "100%",
  "> div": {
    width: "100%",
    "> input": {
      width: "100% !important",
    },
    "> div": {
      display: "none",
    },
  },
};

export default function (isMulti) {
  return {
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
    control: (provided, state) => {
      const closed = {
        ...provided,
        borderStyle: "none",
        boxShadow: "none",
        background: colours.grey4,
        padding: "0.75em 1em",
        borderRadius: "1.875em",
        cursor: "pointer",
      };

      const open = {
        ...closed,
        background: colours.white,
        boxShadow: "0 0 1.875em rgba(194, 195, 199, 0.25)",
        borderRadius: "1.875em 1.875em 0 0",
      };

      return state.menuIsOpen ? open : closed;
    },
    menu: (provided) => ({
      ...provided,
      marginTop: "0",
      borderRadius: "0 0 1.875em 1.875em",
      boxShadow: "0 2em 1.875em rgba(194, 195, 199, 0.25)",
      padding: "1em",
    }),
    menuList: (provided) => ({
      ...provided,
      "scrollbar-color": colours.grey4,
      "scrollbar-width": "thin",
      "::-webkit-scrollbar": {
        width: "5px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        boxShadow: `inset 0 0 6px ${colours.grey4}`,
        borderRadius: "10px",
        margin: "0px 10px 40px 0px",
      },
      "::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        boxShadow: `inset 0 0 6px ${colours.grey2}`,
      },
    }),
    option: (_, state) => ({
      padding: "0.5em",
      ...fonts.input,
      cursor: "pointer",
      color: state.isFocused ? colours.darkBlue : colours.grey2,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: 0,
      ...(state.hasValue ? fonts.inputPopulated : fonts.input),
    }),
    singleValue: (provided, state) => ({
      ...provided,
      ...(state.isDisabled ? { color: "#878CA1" } : {}),
    }),
    indicatorSeparator: (provided, state) => ({
      display: "none",
    }),
    input: (provided) => ({
      ...provided,
      ...(isMulti ? {} : inputOverride),
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#897575",
    }),
    multiValue: (provided) => ({
      ...provided,
      maxHeight: "2.25em",
      padding: "0.5em 1em",
      borderRadius: "3.4375em",
      background: colours.darkBlue + "26",
      color: colours.darkBlue,
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: colours.darkBlue,
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: colours.darkBlue,
      ":hover": {
        background: colours.darkBlue + "26",
      },
    }),
  };
}
